export default "__VITE_ASSET__BPmuF_i$__"